import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createResultApi } from "../../services/result/create.result.api";

export const useCreateResultApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createInfo: any) => createResultApi(createInfo),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["result"],
      });
    },
  });
};
